import { getDefaultHeaders } from './httpUtils'
import { URL_CONST } from './urlConsts'

import 'whatwg-fetch'

const ABSOLUTE_URL_PATTERN = /^[a-z][a-z\d+.-]*:/i

export function request(url, method, body) {
  const options = {
    method,
    headers: {
      'Content-type': 'application/json',
      ...getDefaultHeaders(),
    },
    credentials: 'include',
    body: body && JSON.stringify(body),
  }

  const requestUrl =
    url && !ABSOLUTE_URL_PATTERN.test(url) && !url.startsWith('//')
      ? `${API_BASE_URL || ''}${url.startsWith('/') ? url : `/${url}`}`
      : url

  return fetch(requestUrl, options)
    .then(checkStatus)
    .then(parseJSON)
    .then((data) => ({ data }))
    .catch((err) => ({ err }))
}

function parseJSON(response) {
  return response.json()
}

function checkStatus(response) {
  if (response.status == 401) {
    window.location = `${URL_CONST.login.signin}?next=${encodeURIComponent(
      window.location.pathname + window.location.search
    )}`
  }
  return response

  // if (response.status >= 200 && response.status < 300) {
  //   return response;
  // }
  //
  // const error = new Error(response.statusText);
  // error.response = response;
  // throw error;
}
